<template>
    <div>
        <div class="container mt-4" style="margin-bottom:9rem">
            <boton-atras :nombre_ruta="'menuQuienesSomos'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Información</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <router-link :to="{name:'coberturas'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5>Coberturas</h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>      
                    <router-link :to="{name:'exclusion-de-coberturas'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5>Exclusión de coberturas</h5>
                                </div> 
                            </div> 
                        </div>
                    </router-link>
                    <router-link :to="{name:'validez-de-aseguramiento'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5>Validez de aseguramiento</h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>      
                    <router-link :to="{name:'siniestro'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5> ¿Qué hacer en caso de un siniestro? </h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>
                    <router-link :to="{name:'primas-de-aseguramiento'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5>Primas de aseguramiento</h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>      
                    <router-link :to="{name:'ajustadores-autorizados'}">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col">
                                    <h5>Ajustadores autorizados </h5>
                                </div>
                            </div> 
                        </div>
                    </router-link>       
                </div>
                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/seccionFoprovep/info-foprovep.jpg" alt="">  
                        </div>
                    </div>
                    
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // Variables
        }
    },
    components:{
        botonAtras,
    },
    mounted(){
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{ box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important; }

    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }


    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }
    .card-width{ width: 90%; }
    

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .margenes{justify-content: center;}
}

</style>